/**
 * ⟦C62 · lot 4 · friction 4⟧ **Trois candidats, pas quinze** : le choix de ce qu'on montre d'abord au Marché.
 * Pur (aucun écran, aucun store) : il se teste sans navigateur.
 */

import type { OffreFreelance } from "@maxime/shared";

/** ⟦C62 · lot 4⟧ Combien de candidats on montre d'abord pour une étape. */
export const CANDIDATS_AFFICHES = 3;

/**
 * ⟦C62 · lot 4⟧ **Les candidats à montrer d'abord** : `max` personnes, jamais l'offre entière. Pure, testable.
 *
 * L'offre arrive triée par prix croissant (`offresPourEtape`). Au plus `max` : on la rend telle quelle. Au-delà,
 * dans l'ordre de ce qui compte pour choisir : celui qu'on a déjà retenu (il ne disparaît jamais de l'écran),
 * le moins cher (le tarif d'entrée, quand il y en a un), le meilleur (la cote la plus haute), une personne
 * fidélisée, une pépite, puis celui du milieu. Le tout rendu dans l'ordre des prix.
 */
export function choisirCandidats(
  offres: readonly OffreFreelance[],
  retenuId: string | undefined,
  max: number = CANDIDATS_AFFICHES,
): readonly OffreFreelance[] {
  if (offres.length <= max) return offres;
  const meilleur = offres.reduce((m, o) => (o.cote > m.cote ? o : m), offres[0]!);
  const priorite: (OffreFreelance | undefined)[] = [
    offres.find((o) => o.id === retenuId),
    offres[0],
    meilleur,
    offres.find((o) => o.fidelise),
    offres.find((o) => o.pepite),
    offres[Math.floor((offres.length - 1) / 2)],
  ];
  const gardes = new Set<string>();
  for (const o of priorite) {
    if (o !== undefined && gardes.size < max) gardes.add(o.id);
  }
  return offres.filter((o) => gardes.has(o.id));
}
